import script from "./AttributionComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./AttributionComponent.vue?vue&type=script&setup=true&lang=js"

import "./AttributionComponent.vue?vue&type=style&index=0&id=3188a240&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3188a240"]])

export default __exports__